import React from 'react'

const Terms = () => (
  <p style={{ margin: 10, textAlign: "center" }}>Terms of Service coming soon!</p>
)

export default Terms